// extracted by mini-css-extract-plugin
export var galleryHeader = "galleryheader-module--galleryHeader--uRQC+";
export var hr = "galleryheader-module--hr--bToY-";